var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUp(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1325 10.3725C19.6225 9.8825 19.6225 9.0925 19.1325 8.6025L10.8225 0.2925C10.4325 -0.0975004 9.8025 -0.0975004 9.4125 0.2925L1.1025 8.6025C0.612499 9.0925 0.612499 9.8825 1.1025 10.3725C1.5925 10.8625 2.3825 10.8625 2.8725 10.3725L10.1225 3.1325L17.3725 10.3825C17.8525 10.8625 18.6525 10.8625 19.1325 10.3725Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAyMCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjEzMjUgMTAuMzcyNUMxOS42MjI1IDkuODgyNSAxOS42MjI1IDkuMDkyNSAxOS4xMzI1IDguNjAyNUwxMC44MjI1IDAuMjkyNUMxMC40MzI1IC0wLjA5NzUwMDQgOS44MDI1IC0wLjA5NzUwMDQgOS40MTI1IDAuMjkyNUwxLjEwMjUgOC42MDI1QzAuNjEyNDk5IDkuMDkyNSAwLjYxMjQ5OSA5Ljg4MjUgMS4xMDI1IDEwLjM3MjVDMS41OTI1IDEwLjg2MjUgMi4zODI1IDEwLjg2MjUgMi44NzI1IDEwLjM3MjVMMTAuMTIyNSAzLjEzMjVMMTcuMzcyNSAxMC4zODI1QzE3Ljg1MjUgMTAuODYyNSAxOC42NTI1IDEwLjg2MjUgMTkuMTMyNSAxMC4zNzI1WiIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };